import script from "./nameEditPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./nameEditPopup.vue?vue&type=script&setup=true&lang=ts"

import "./nameEditPopup.vue?vue&type=style&index=0&id=83046cea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83046cea"]])

export default __exports__